import { Injectable } from '@angular/core';

import { map, merge, Observable, tap } from 'rxjs';

import { FloorPlan } from '@shared/floor-plan/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import { FloorPlanQuery, FloorPlanStore } from './floor-plan-state';
import { FloorPlanApiService } from './floor-plan-api.service';
import { SocketService } from '@tablesready/frontend-store';

@Injectable({ providedIn: 'root' })
export class FloorPlanService {
  constructor(
    private readonly query: FloorPlanQuery,
    private readonly store: FloorPlanStore,
    private readonly floorPlanApiService: FloorPlanApiService,
    private readonly socketService: SocketService,
  ) { }

  load(): Observable<FloorPlan[]> {
    return this.floorPlanApiService.getList().pipe(tap((floorPlans) => {
      this.store.set(floorPlans);
    }));
  }

  reset(): void {
    this.store.reset();
  }

  select(): Observable<FloorPlan[]> {
    return this.query.select()
      .pipe(map((state) => {
        const plans: FloorPlan[] = [];
        Object.entries(state.entities).forEach(([, value]) => {
          plans.push(value);
        });

        return plans;
      }));
  }

  listenToChanges() {
    return merge(
      this.socketService
        .getEventStream<FloorPlan[]>(WebSocketEventsEnum.floorPlanCreated)
        .pipe(tap((floorPlan) => {
          this.store.add(floorPlan);
        })),
      this.socketService
        .getEventStream<FloorPlan[]>(WebSocketEventsEnum.floorPlanUpdated)
        .pipe(tap((floorPlans) => {
          for (let i = 0; i < floorPlans.length; i++) {
            this.store.update(floorPlans[i].id, floorPlans[i]);
          }
        })),
      this.socketService
        .getEventStream<string[]>(WebSocketEventsEnum.floorPlanDeleted)
        .pipe(tap(ids => this.store.remove(ids))),
    );
  }
}
